import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectRoleRequest } from "../../redux/actions/authenticationActions";
import { FormSelect } from "react-bootstrap";

const RoleSwitcher = ({ userGroups, doRedirect }) => {
    const dispatch = useDispatch();
    const selectedRole = useSelector(state => state.authentication.selectedRole);
    const navigate = useNavigate();

    const handleRoleChange = (event) => {
        const newRole = event.target.value;
        dispatch(selectRoleRequest({ selectedRole: newRole}));
        localStorage.setItem('selectedRole', newRole);

        if (doRedirect) {
            // Navigieren Sie direkt basierend auf der neuen Rolle
            switch (newRole) {
                case 'staffmembers':
                    navigate('/mdb/staff');
                    break;
                case 'humanressource':
                    navigate('/mdb/hr');
                    break;
                case 'institute':
                case 'assistant':
                    navigate('/mdb/institute');
                    break;
                case 'rectorate':
                    navigate('/mdb/rectorate');
                    break;
                case 'school':
                    navigate('/mdb/school');
                    break;
                case 'federalstate':
                    navigate('/mdb/federalstate');
                    break;
                case 'admin':
                    navigate('/mdb/admin');
                    break;
                default:
                    console.log('Keine gültige Rolle ausgewählt');
            }
        }
    };

    return (
        <FormSelect
            className="form-select"
            value={selectedRole || ''}
            onChange={handleRoleChange}
        >
            <option value="" disabled>Rolle wechseln</option>
            {userGroups.map((group) => (
                <option key={group} value={group}>
                    {
                        group === 'staffmembers' ? 'Mitarbeiter' :
                        group === 'humanressource' ? 'Personal' :
                        group === 'institute' ? 'Institut' :
                        group === 'assistant' ? 'Assistent' :
                        group === 'rectorate' ? 'Rektorat' :
                        group === 'school' ? 'Schule' :
                        group === 'federalstate' ? 'Bildungsdirektion' :
                        group === 'admin' ? 'Admin' : group
                    }
                </option>
            ))}
        </FormSelect>
    );
};

export default RoleSwitcher;
